import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

const CopyBtn = ({ id, disable = false, onCopy }: Pick<IToolLayout & ICallback, 'id' | 'disable' | 'onCopy'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();

    /** 重置 preAddLayerId */
    useEffect(() => {
        return () => {
            editor.layer.resetPreAddLayerId();
        };
    }, [id]);

    return (
        <Tooltip placement="bottom" title={$t((v) => v.headerToolbar.copyBtn.copyText)}>
            <div
                className={classNames('c-header-toolbar-actions-btn', {
                    disable,
                })}
                onClick={() => {
                    if (disable) return;
                    editor.layer.clone(id);
                    onCopy?.();
                }}
            >
                <IconFont fontSize={14} name="DuplicateBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(CopyBtn);
